/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WsDomain } from './WsDomain';
import {
    WsDomainFromJSON,
    WsDomainFromJSONTyped,
    WsDomainToJSON,
    WsDomainToJSONTyped,
} from './WsDomain';
import type { WsMember } from './WsMember';
import {
    WsMemberFromJSON,
    WsMemberFromJSONTyped,
    WsMemberToJSON,
    WsMemberToJSONTyped,
} from './WsMember';

/**
 * 
 * @export
 * @interface Workspace
 */
export interface Workspace {
    /**
     * Unique identifier of the workspace
     * @type {string}
     * @memberof Workspace
     */
    id: string;
    /**
     * Display name of the workspace
     * @type {string}
     * @memberof Workspace
     */
    name: string;
    /**
     * URL-friendly slug for the workspace
     * @type {string}
     * @memberof Workspace
     */
    slug: string;
    /**
     * URL of the workspace avatar image
     * @type {string}
     * @memberof Workspace
     */
    avatarUrl: string;
    /**
     * List of members belonging to this workspace
     * @type {Array<WsMember>}
     * @memberof Workspace
     */
    members: Array<WsMember>;
    /**
     * List of domains associated with this workspace
     * @type {Array<WsDomain>}
     * @memberof Workspace
     */
    domains: Array<WsDomain>;
}

/**
 * Check if a given object implements the Workspace interface.
 */
export function instanceOfWorkspace(value: object): value is Workspace {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('domains' in value) || value['domains'] === undefined) return false;
    return true;
}

export function WorkspaceFromJSON(json: any): Workspace {
    return WorkspaceFromJSONTyped(json, false);
}

export function WorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Workspace {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'slug': json['slug'],
        'avatarUrl': json['avatarUrl'],
        'members': ((json['members'] as Array<any>).map(WsMemberFromJSON)),
        'domains': ((json['domains'] as Array<any>).map(WsDomainFromJSON)),
    };
}

export function WorkspaceToJSON(json: any): Workspace {
    return WorkspaceToJSONTyped(json, false);
}

export function WorkspaceToJSONTyped(value?: Workspace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'avatarUrl': value['avatarUrl'],
        'members': ((value['members'] as Array<any>).map(WsMemberToJSON)),
        'domains': ((value['domains'] as Array<any>).map(WsDomainToJSON)),
    };
}

